var r = function r(_r) {
  try {
    return !!_r();
  } catch (r) {
    return !0;
  }
};
export { r as f };